import { StructureDto } from './structure-dto.model';

export class ParametreContextuelDto {
  public usage: string;
  public typeOffre: string;
  public solution?: string;
  public editeurSolution?: string;
  public typeParametre?: string;
  public restriction?: string;
  public domaine?: string;
  public cleStructurePerimetreContractuel?: string;
  public isValid: boolean;
  public motif?: string;
  public autreMotif?: string;
  public etat?: string;
  public creationDate?: Date;
  public dateValidation?: Date;
  public structurePerimetreContractuel?: StructureDto;
  public libelleMotif?: string;
}

/**
 * Enum to define a parametre contextuel etat
 */
export enum ParametreContextuelEtat {
  VALIDE = 'VALIDE',
  ATTENTE_VALIDATION = 'ATTENTE_VALIDATION',
  DETACHE = 'DETACHE',
  REJETE = 'REJETE',
}
